import React, { useState, useEffect, useCallback } from "react";
import {
  Divider,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Skeleton,
} from "@chakra-ui/react";
import { AiOutlineMenu, AiOutlinePlus } from "react-icons/ai";
import { TbDirection, TbGridDots, TbTrashFilled } from "react-icons/tb";
import { MdEdit, MdSearch } from "react-icons/md";
import { enqueueSnackbar, useSnackbar } from "notistack";
import api from "../../../api";
import { useNavigate, Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import NoData from "../../../components/NoData";
import { ClipLoader } from "react-spinners";

const CustomSkeletonLoader = ({ count }) => {
  const skeletonRows = Array.from({ length: count }, (_, index) => (
    <tr key={index}>
      <td className="text-center" style={{ height: "65px" }}>
        <Skeleton width="100%" height="50px" />
      </td>
      <td className="fs-6 text-center ">
        <Skeleton width="100%" height="50px" />
      </td>
      <td className="fs-6 text-center ">
        <Skeleton width="100%" height="50px" />
      </td>
      <td className="text-center" style={{ cursor: "pointer", width: "40px" }}>
        <Skeleton width="60%" height="25px" />
        <Skeleton width="60%" height="25px" marginTop="10px" />
      </td>
    </tr>
  ));

  return skeletonRows;
};

const Leave = () => {
  const [page, setPage] = useState(1);
  const [isDeleteModal, setIsDeleteModal] = useState(false);
  const [resultId, setResultId] = useState("");
  const [loading, setIsLoading] = useState(false);
  function ToggleDeleteModal(id) {
    setIsDeleteModal(!isDeleteModal);
    setResultId(id);
  }
    function closeDeleteModal() {
    setIsDeleteModal(false);
  }

    const DeleteLeave = async () => {
    setIsLoading(true);

    try {
      const response = await api.deleteLeave(resultId);
      enqueueSnackbar(response?.message, { variant: "success" });
      refetch();
      setIsLoading(false);
      closeDeleteModal(false);
      setResultId("");
    } catch (error) {
      enqueueSnackbar(error.message, { variant: "error" });

      setIsLoading(false);
    }
  };

  const navigate = useNavigate();

  async function getLeaves(page) {
    const response = await api.fetchLeaves({ params: { page } });
    return response;
  }

  const { isLoading, isError, data, error, isPreviousData, refetch } = useQuery(
    ["leaveRequests", page],
    () => getLeaves(page),
    {
      keepPreviousData: true,
      refetchOnWindowFocus: "always",
    }
  );

  function formatDate(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Adding 1 to month since it's zero-based
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  return (
    <div className="md:p-[20px] p-[10px] bg-[#F2F2F2] min-h-screen ">
      <div className="border-[0.2px] border-[#98a2b3] rounded-[8px]  bg-[#984779] ">
        <div className=" h-full p-[16px] md:p-[20px] block md:flex justify-between items-center md:flex-wrap w-full ">
          <div className="flex items-center gap-[16px]">
            <div className="flex items-center">
              <h3 className="text-[#fff] text-[14px] md:text-[14px] mb-0 xl:text-[16px] font-semibold leading-[24px]  ">
                Leave Applications
              </h3>
            </div>
            <div className="h-[32px] w-[1px] bg-[#D0D5DD]" />
            {/* <div className="flex flex-1 items-center gap-[8px]">
              <SearchNormal1 variant="Linear" color="#fefefe" size="16" />
              <input
                className="w-full lg:w-[300px] text-sm py-[6px] px-3 text-[16px] text-[#344054] leading-[20px] placeholder:text-[#98A2B3] placeholder:text-[12px] border border-transparent  focus:outline-none focus:ring-[#26ae5f] focus:border-b-[#26ae5f] "
                placeholder="Search by office name.."
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
              />
            </div> */}
            {/* <button onClick={toggleCreateModal} className="rounded-lg py-2 px-3 bg-[#fefefe] text-sm hover:bg-gray-100">Create Office</button> */}
          </div>
        </div>
      </div>
      {/* Desktop Table View */}
      <div className="hidden md:block overflow-x-auto">
        <div class="sm:-mx-6 lg:-mx-8 mt-5">
          <div class="inline-block min-w-full  sm:px-6 lg:px-8">
            <div class="overflow-x-auto rounded-lg">
              <table className="min-w-full mb-6 border-[0.8px] border-r-[0.8px]  border-l-[0.8px] border-[#E4E7EC] rounded-lg">
                <thead className="bg-[#F9FAFB]">
                  <tr className="">
                    <th
                      scope="col"
                      className="  border-b-[0.8px] border-[#E4E7EC] py-[12px] px-3  gap-[6px] md:gap-[12px] text-[14px] md:text-[16px] text-[#98A2B3]  font-medium leading-[20px] md:leading-[24px] tracking-[0.2%]"
                    >
                      <div className="flex px-3 whitespace-nowrap    gap-[6px] md:gap-[12px] items-center">
                        Staff Name
                      </div>
                    </th>
                    <th
                      scope="col"
                      className="  border-b-[0.8px] border-[#E4E7EC] py-[12px] px-3  gap-[6px] md:gap-[12px] text-[14px] md:text-[16px] text-[#98A2B3]  font-medium leading-[20px] md:leading-[24px] tracking-[0.2%]"
                    >
                      <div className="flex whitespace-nowrap  gap-[6px] md:gap-[12px] ">
                        Leave Type{" "}
                      </div>
                    </th>

                    <th
                      scope="col"
                      className="  border-b-[0.8px] border-[#E4E7EC] py-[12px] gap-[6px] md:gap-[12px] text-[14px] md:text-[16px] text-[#98A2B3]  font-medium leading-[20px] md:leading-[24px] tracking-[0.2%]"
                    >
                      <div className="flex justify-center gap-[6px] md:gap-[12px] items-center my-0">
                        Status
                      </div>
                    </th>
                    <th
                      scope="col"
                      className="  border-b-[0.8px] border-[#E4E7EC] py-[12px] gap-[6px] md:gap-[12px] text-[14px] md:text-[16px] text-[#98A2B3]  font-medium leading-[20px] md:leading-[24px] tracking-[0.2%]"
                    >
                      <div className="flex justify-center gap-[6px] md:gap-[12px] items-center my-0">
                        Date Applied
                      </div>
                    </th>
                    <th
                      scope="col"
                      className="  border-b-[0.8px] border-[#E4E7EC] py-[12px] gap-[6px] md:gap-[12px] text-[14px] md:text-[16px] text-[#98A2B3]  font-medium leading-[20px] md:leading-[24px] tracking-[0.2%]"
                    >
                      <div className="flex justify-center gap-[6px] md:gap-[12px] items-center my-0">
                        Department
                      </div>
                    </th>
                    <th
                      scope="col"
                      className="  border-b-[0.8px] border-[#E4E7EC] py-[12px] gap-[6px] md:gap-[12px] text-[14px] md:text-[16px] text-[#98A2B3]  font-medium leading-[20px] md:leading-[24px] tracking-[0.2%]"
                    >
                      <div className="flex justify-center gap-[6px] md:gap-[12px] items-center my-0">
                        Action
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {isLoading && <h3 className="text-sm">Loading....</h3>}
                  {data && data?.data?.length === 0 && <NoData />}

                  {data &&
                    data?.data?.map((item) => (
                      <tr key={item.id} className="mb-2 hover:bg-light-gray">
                        <td className="whitespace-wrap py-[10px] bg-white  px-3  border-b-[0.8px] border-[#E4E7EC] text-[14px] leading-[24px] tracking-[0.2px] text-[#667185] font-medium text-left  ">
                          <div className="flex items-center  gap-2">
                            <img
                              src={item.user_image}
                              className="h-[40px] md:h-[50px] w-[40px] md:w-[50px] rounded-full "
                              alt=""
                            />
                            <div>
                              <p className="mb-0">{item.full_name}</p>
                            </div>
                          </div>
                        </td>
                        <td className="whitespace-nowrap py-[10px] bg-white  px-3  border-b-[0.8px] border-[#E4E7EC] text-[14px] leading-[24px] tracking-[0.2px] text-[#667185] font-medium text-left  ">
                          {item.leave_type}
                        </td>
                        <td className="whitespace-nowrap py-[10px] bg-white  px-3  border-b-[0.8px] border-[#E4E7EC] text-[14px] leading-[24px] tracking-[0.2px] text-[#667185] font-medium text-left  ">
                          <button
                            className={`text-sm font-normal border p-1 px-2 rounded-lg ${
                              item.status === "approved"
                                ? "text-[#388B41] border-[#388B41]"
                                : item.status === "pending"
                                ? "text-[#FFA043] border-[#FFA043]"
                                : item.status === "declined"
                                ? "text-[#FC3400] border-[#FC3400]"
                                : null
                            }`}
                          >
                            {item.status}
                          </button>
                        </td>
                        <td className="whitespace-nowrap py-[10px] bg-white  px-3  border-b-[0.8px] border-[#E4E7EC] text-[14px] leading-[24px] tracking-[0.2px] text-[#667185] font-medium text-center  ">
                          {formatDate(item.date)}
                        </td>
                        <td className="whitespace-nowrap py-[10px] bg-white  px-3  border-b-[0.8px] border-[#E4E7EC] text-[14px] leading-[24px] tracking-[0.2px] text-[#667185] font-medium text-center ">
                          {item.department?.name ||
                            item.faculty?.name ||
                            item.unit?.name}
                        </td>

                        <td className="whitespace-nowrap py-[16px]  bg-white   px-3  border-b-[0.8px] border-[#E4E7EC] text-[14px] leading-[24px] tracking-[0.2px] text-[#1A202C] font-medium text-center  ">
                        <div className="flex items-center gap-3">
                          <Link to={`leave-applicant-details/${item.id}`}>
                            <button
                              className="btn py-1 px-3 rounded-0 btn-sm rounded-0 fw-semibold"
                              style={{
                                border: "1px solid #984779",
                                color: "#987779",
                                backgroundColor: "#E9EBFD",
                              }}
                            >
                              View Application
                            </button>
                          </Link>
                          <button onClick={() => ToggleDeleteModal(item?.id)}>
                            <TbTrashFilled size={20} color="purple"/>
                          </button>
                          </div>  
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Card View */}
      <div className="md:hidden mt-5 space-y-4 px-4">
        {isLoading && <div className="text-center py-4">Loading....</div>}
        {data && data?.data?.length === 0 && <NoData />}
        
        {data &&
          data?.data?.map((item) => (
            <div key={item.id} className="bg-white border border-[#E4E7EC] rounded-lg p-4 shadow-sm">
              <div className="flex items-start justify-between mb-3">
                <div className="flex items-center gap-3">
                  <img
                    src={item.user_image}
                    className="h-[50px] w-[50px] rounded-full object-cover"
                    alt=""
                  />
                  <div>
                    <h3 className="font-semibold text-[#1A202C] text-sm">
                      {item.full_name}
                    </h3>
                    <p className="text-xs text-[#667185]">{item.leave_type}</p>
                  </div>
                </div>
                <button
                  className={`text-xs font-normal border px-2 py-1 rounded-lg ${
                    item.status === "approved"
                      ? "text-[#388B41] border-[#388B41]"
                      : item.status === "pending"
                      ? "text-[#FFA043] border-[#FFA043]"
                      : item.status === "declined"
                      ? "text-[#FC3400] border-[#FC3400]"
                      : null
                  }`}
                >
                  {item.status}
                </button>
              </div>
              
              <div className="grid grid-cols-2 gap-3 text-xs mb-4">
                <div>
                  <span className="font-medium text-[#98A2B3]">Date Applied:</span>
                  <p className="text-[#667185]">{formatDate(item.date)}</p>
                </div>
                <div>
                  <span className="font-medium text-[#98A2B3]">Department:</span>
                  <p className="text-[#667185]">
                    {item.department?.name ||
                      item.faculty?.name ||
                      item.unit?.name}
                  </p>
                </div>
              </div>
              
              <div className="flex justify-between items-center">
                <Link to={`leave-applicant-details/${item.id}`}>
                  <button
                    className="text-xs py-2 px-4 rounded border border-[#984779] text-[#984779] bg-[#E9EBFD] hover:bg-[#d4d8f7] transition-colors"
                  >
                    View Application
                  </button>
                </Link>
                <button 
                  onClick={() => ToggleDeleteModal(item?.id)}
                  className="p-2 text-purple-600 hover:bg-purple-50 rounded transition-colors"
                >
                  <TbTrashFilled size={18} />
                </button>
              </div>
            </div>
          ))}
      </div>
      {/* Pagination */}
      {data && data.data && data?.data?.length > 0 && (
        <div className="px-4 py-4 border-t border-[#E4E7EC] bg-white">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <div className="text-sm text-gray-500 text-center sm:text-left">
              <span>
                Showing {data?.meta?.from} - {data.meta?.to} of{" "}
                {data?.meta?.total} results
              </span>
              <span className="mx-2">|</span>
              <span>
                Page {data?.meta?.current_page} of {data?.meta?.last_page}
              </span>
            </div>
            <div className="flex gap-2">
              <button
                onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
                disabled={
                  data?.meta?.current_page === 1 || isPreviousData
                }
                className="px-3 py-1 text-sm border border-gray-300 rounded-md disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50 transition-colors"
              >
                Prev
              </button>
              <button
                onClick={() => setPage((prev) => prev + 1)}
                disabled={
                  data?.meta?.current_page === data?.meta?.last_page ||
                  isPreviousData
                }
                className="px-3 py-1 text-sm border border-gray-300 rounded-md disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50 transition-colors"
              >
                Next
              </button>
            </div>
          </div>
        </div>
      )}

      <Modal
        isCentered
        isOpen={isDeleteModal}
        onClose={closeDeleteModal}
        size={{ base: "xs", sm: "md", lg: "xl" }}
        style={{ borderRadius: 12 }}
        motionPreset="slideInBottom"
        className="rounded-[12px]"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader
            py="4"
            color="#000000"
            className="text-[18px]   font-medium leading-[24px] md:leading-[24px]"
          >
            <svg
              className="mx-auto"
              width="56"
              height="56"
              viewBox="0 0 56 56"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect x="4" y="4" width="48" height="48" rx="24" fill="#984779" />
              <rect
                x="4"
                y="4"
                width="48"
                height="48"
                rx="24"
                stroke="#FEECEB"
                stroke-width="8"
              />
              <path
                d="M28 38C33.5 38 38 33.5 38 28C38 22.5 33.5 18 28 18C22.5 18 18 22.5 18 28C18 33.5 22.5 38 28 38Z"
                stroke="#fff"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M28 24V29"
                stroke="#fff"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M27.9961 32H28.0051"
                stroke="#fff"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </ModalHeader>
          <ModalCloseButton size={"sm"} />
          <ModalBody
            py={{ base: "20px", md: "24px" }}
            px={{ base: "16px", md: "24px" }}
            className=" px-[16px] md:px-[24px] pb-[30px] md:pb-[40px]"
          >
            <p className=" text-[16px] md:text-lg text-center  text-[#000] leading-[24px] font-medium  ">
              Delete Leave
            </p>

            <p className="text-[14px]  text-[#667185] leading-[20px] font-normal text-center mt-2  ">
              Are you sure you want to delete this Leave? This action cannot be
              undone.
            </p>
          </ModalBody>
          <ModalFooter gap={"16px"}>
            <button
              onClick={closeDeleteModal}
              className="border-[0.2px]  border-[#98A2B3] w-[99px] text-center rounded-[8px] py-[12px] text-[14px] font-medium text-black"
            >
              Cancel
            </button>
            <button
              onClick={DeleteLeave}
              className="border-[0.2px]  border-[#98A2B3] w-[99px] bg-[#984779] flex items-center justify-center text-center rounded-[8px] py-[12px] text-[14px] font-medium text-white"
            >
              {loading ? (
                <ClipLoader color={"white"} size={20} />
              ) : (
                <> Delete </>
              )}
            </button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </div>
  );
};

export default Leave;
